export const chat_status_style ={
    rootsx:{
        
    }
}